const helpers = {};

helpers.camelToWords = (camelCaseString) => {
  // Use a regular expression to insert a space before all caps and lowercase the string
  return camelCaseString.replace(/([a-z])([A-Z])/g, "$1 $2");
};

export default helpers;
